import React from 'react'

const walletAdd = () => {

  const styles = {
    container: {
      maxWidth: '400px',
      margin: 'auto',
      padding: '20px',
      borderRadius: '8px',
      backgroundColor: '#f8f9fa',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
    },
    qrImage: {
      width: '50px',
      height: '50px',
      marginBottom: '20px',
    },
    paymentInfo: {
      backgroundColor: '#d50000',
      color: '#fff',
      padding: '15px',
      borderRadius: '8px',
      textAlign: 'left',
      marginBottom: '20px',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
    },
    label: {
      fontSize: '14px',
      color: '#333',
      fontWeight: 'bold',
    },
    input: {
      width: '100%',
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      fontSize: '14px',
      marginTop: '5px',
    },
    fileInput: {
      marginTop: '5px',
    },
    submitButton: {
      backgroundColor: '#ffc107',
      border: 'none',
      color: '#fff',
      padding: '10px 15px',
      fontSize: '16px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: 'bold',
    },
  };

  
  return (
    <div>

      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
          <div style={styles.container}>
      {/* QR Image */}
      <img src="https://via.placeholder.com/100" alt="QR" style={styles.qrImage} />

      {/* Payment Info */}
      <div style={styles.paymentInfo}>
        <p><strong>UPI:</strong> Test</p>
        <p><strong>All Payment No.:</strong> Test</p>
        <p><strong>Bank:</strong> Test</p>
        <p><strong>Account No.:</strong> Test</p>
        <p><strong>IFSC:</strong> Test</p>
      </div>

      {/* Form */}
      <form style={styles.form}>
        <label style={styles.label}>
          Amount
          <input type="number" value="40000" style={styles.input} readOnly />
        </label>

        <label style={styles.label}>
          Upload Payment Screenshot
          <input type="file" style={styles.fileInput} />
        </label>

        <button type="submit" style={styles.submitButton}>
          Submit
        </button>
      </form>
    </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default walletAdd



   
